import { z } from "zod";

//ManutencaoSchema

export const ManutencaoSchema = z.object({
    idManutencao: z.coerce.number().optional().nullable(),
    status: z.coerce.number().optional().default(0),
    nroManutencao: z.coerce.number().optional().nullable(),
    tipoManutencao: z.coerce.number().optional().nullable(),
    idMaquinaEquip: z.coerce.number().optional().nullable(),
    idCentroCusto: z.coerce.number().optional().nullable(),
    idFuncionarioSolicitante: z.coerce.number().optional().nullable(),
    idFuncionarioAprovacao: z.coerce.number().optional().nullable(),
    idFornecedorResponsavel: z.coerce.number().optional().nullable(),
    idFuncionarioResponsavel: z.coerce.number().optional().nullable(),
    valorOrcamento: z.coerce.number().optional().nullable(),
    dataPrevConclusao: z.coerce.date().optional().nullable(),
    dataConclusao: z.coerce.date().optional().nullable(),
    dataAprovacao: z.coerce.date().optional().nullable(),
    descricao: z.string().optional().nullable(),
    observacao: z.string().optional().nullable(),
    motivoReprovacao: z.string().optional().nullable(),
    dataSolicitacao: z.coerce.date().optional().nullable(),

    nomeArquivo1: z.string().nullable().optional(),
    nomeArquivo2: z.string().nullable().optional(),
    nomeArquivo3: z.string().nullable().optional(),
    arquivo1: z.instanceof(File).nullable().default(null),
    arquivo2: z.instanceof(File).nullable().default(null),
    arquivo3: z.instanceof(File).nullable().default(null),

    limparArquivo1: z.boolean().optional().default(false),
    limparArquivo2: z.boolean().optional().default(false),
    limparArquivo3: z.boolean().optional().default(false),

});

// ManutencaoForm
export type ManutencaoForm = z.infer<typeof ManutencaoSchema>;

export const defaultManutencaoForm: Partial<ManutencaoForm> = {
    idManutencao: null,
    status: 0,
    nroManutencao: null,
    tipoManutencao: 1,
    idMaquinaEquip: null,
    idCentroCusto: null,
    idFuncionarioSolicitante: null,
    idFuncionarioAprovacao: null,
    idFornecedorResponsavel: null,
    idFuncionarioResponsavel: null,
    valorOrcamento: null,
    dataPrevConclusao: null,
    dataConclusao: null,
    dataAprovacao: null,
    descricao: null,
    observacao: null,
    motivoReprovacao: null,
    dataSolicitacao: null,
};